import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/ReferralTerms/GET';

export const REFERRAL_TERMS_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const REFERRAL_TERMS_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
